/* cds-mobile-fixes.js — touch interaction patches, runs after cds-landing.js (defer order). */
(function(){
  'use strict';
  /* Desktop (hover:hover): cds-landing.js handles this correctly. Bail. */
  if (!matchMedia('(hover:none)').matches) return;

  var list = document.querySelector('.anatomy-list');
  var viz  = document.querySelector('.anatomy-viz');
  if (!list) return;

  /* Swap "hover" hint copy to "tap" */
  var hintSpan = document.querySelector('.anh-hint span');
  if (hintSpan && hintSpan.firstChild && hintSpan.firstChild.nodeType === 3) {
    hintSpan.firstChild.nodeValue = 'Tap a component to inspect ';
  }

  /* Set --sx/--sy on the viz and add .focused — triggers the CSS zoom transform.
     Reading pin.style.left/top works even when pin is display:none; the inline
     style attribute is always present regardless of visibility. */
  function applyFocus(step) {
    if (!viz) return;
    var pin = viz.querySelector('.an-pin[data-step="' + step + '"]');
    if (pin) {
      viz.style.setProperty('--sx', pin.style.left);
      viz.style.setProperty('--sy', pin.style.top);
      viz.classList.add('focused');
    }
  }

  function clearFocus() {
    if (viz) viz.classList.remove('focused');
  }

  /* Clone each anatomy item to shed cds-landing.js's event listeners, then
     wire mobile-aware tap behaviour:
       • tap → zoom image to that component (CSS transition), expand description
       • tap same item again → zoom back out, collapse (toggle)
       • tap a different item while one is open → image pans smoothly to the
         new component (--sx/--sy update while .focused stays on viz, so the
         CSS transition animates from the old position to the new one) */
  [].slice.call(list.querySelectorAll('.anatomy-item')).forEach(function(item){
    var fresh = item.cloneNode(true);
    item.parentNode.replaceChild(fresh, item);

    fresh.addEventListener('click', function(){
      var wasActive = fresh.classList.contains('active');

      /* Collapse all items */
      [].slice.call(list.querySelectorAll('.anatomy-item')).forEach(function(o){
        o.classList.remove('active');
      });

      if (wasActive) {
        /* Toggle off: zoom back out */
        clearFocus();
      } else {
        /* Expand: zoom to this component and show its description */
        fresh.classList.add('active');
        applyFocus(fresh.dataset.step);
        setTimeout(function(){
          fresh.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 120);
      }
    });
  });
})();
